import { useSelector } from 'react-redux';
import { toLocaleFromHostname } from '@peloton/internationalize';
import {
  formatMoney,
  toMoney,
  toCurrencyFromLocale,
  formatMoneyNoZeroDecimals,
} from '@peloton/internationalize/models/currency';
import type { ReducerState } from '@peloton/subscription-plans';
import { getRollOverPrice } from '@peloton/subscription-plans/selectors';

/** Uses TLD to determine locale as this is how we determine which currency symbol to show */

export const useLocalizedMonthlyMembershipPrice = (sku: string) => {
  const costInCents = useSelector((state: ReducerState) => getRollOverPrice(state, sku));
  const locale = toLocaleFromHostname();
  const monthlyPrice = formatMoney(toMoney(costInCents, toCurrencyFromLocale(locale)));
  return monthlyPrice;
};

export const useLocalizedMonthlyMembershipPriceNoZeroDecimals = (sku: string) => {
  const costInCents = useSelector((state: ReducerState) => getRollOverPrice(state, sku));
  const locale = toLocaleFromHostname();
  const monthlyPrice = formatMoneyNoZeroDecimals(
    toMoney(costInCents, toCurrencyFromLocale(locale)),
  );
  return monthlyPrice;
};
